import {nl} from 'locale/nl'
import {en} from 'locale/en'

export const fr: typeof nl = en
